export default __webpack_public_path__ + "static/homeImg1-42d55c9812a90cd0091eebf869a737a4.jpeg";